const path = "src/assets/i18n";

/*
 * Also update these places:
 * - `tools/docker/initializer/tolgee-create-project.json`
 */
export enum Language {
	"cs-CZ" = "cs-CZ",
}
export const namespaces = ["", "global", "schema"] as const;

const languages = Object.values(Language);

export default {
	parser: "svelte",
	patterns: ["src/**/*.svelte", "src/**/*.ts", "src/**/*.js"],
	pull: {
		languages,
		namespaces,
		path,
	},
	push: {
		files: languages
			.map((language) =>
				namespaces.map((namespace) => ({
					path: namespace === "" ? `${path}/${language}.json` : `${path}/${namespace}/${language}.json`,
					language,
					namespace: namespace || undefined,
				})),
			)
			.flat(),
		languages,
		namespaces,
	},
	strictNamespace: true,
};
